export const sidebar_width_lg = '230px';
export const sidebar_width_sm = '210px';
export const sidebar_width_xs = '180px';